import { RoutingEntry, RoutingLoadableFiles } from '@routing';
import { __asyncI18n } from '@localisation';
import { WinFormsContentScreen } from '@winforms';
import { RoutePrivilegeNames } from './routeprivilegenames';
import { PreregisterNavigationAccessService, PreregisterComponent } from '@preregister';
import { DummySiteComponent } from '@site-info';
import {  DigitalWalletNavigationAccess } from '@billing';
import { TenantRoutes } from './tenant.routes';
/*
import {
    BillingProductsComponent,
    BillingProductComponent,
    DigitalWalletNavigationAccess,
    OverviewComponent,
    TransferComponent,
    DepositComponent,
    StoreComponent,
    TransferAccessService,
    DepositAccessService,
    DepositOnlyAccessService
} from '@billing';*/
import { M2MRouterComponent, M2MRouterDetailComponent } from '@m2m-router';
import { GlobalNotificationAdministrationComponent } from 'modules/notification-module/global-notification-administration.component';
import { LicenseListComponent, LicenseDetailsComponent } from '@license';
import { ThirdPartyAppsListComponent } from '../modules/third-party-apps-module/third-party-apps-list.component';
import { ThirdPartyAppComponent } from 'modules/third-party-apps-module/third-party-app.component';
import { ThirdPartyAppRegisterComponent } from 'modules/third-party-apps-module/third-party-app.register.component';
import { FavouriteTileTokens } from '@favourites';
import { PlantAdministrationRoutes } from './plant-administration.routes';
import { SystemAdministrationRoutes } from './system-administration.routes';
import { UserRoutes } from './user.routes';
import { NewTenantRoutes } from './new-tenant.routes';
import { BatchUpgradeListComponent, BatchUpgradeScheduleListComponent } from '@upgrade';
import { BatchUpgradeDetailsComponent } from '../modules/upgrade-module';

const userRoleTitle = ':userroleid | userRolesIdToName';

export const AdministrationRoutes: Array<RoutingEntry> = [
    {
        path: 'Systems',
        data: {
            title: __asyncI18n('Systems', 'subnavi.administration.systems'),
            category: 'administration',
            testId: 'sidenavigation.link.systems',
            dontShowFavourites: true,
            favouritesType: 'siteadministration',
            privileges: [
                RoutePrivilegeNames.Systems
            ],
            favouritesTitle: '[ParentPageName]',
        },
        children: [
            ...SystemAdministrationRoutes
        ]
    },
    {
        path: 'Plants',
        data: {
            title: __asyncI18n('Plants', 'subnavi.administration.plants'),
            category: 'administration',
            testId: 'sidenavigation.link.plants',
            favouritesType: 'siteadministration',
            privileges: [
                RoutePrivilegeNames.PlantsUnassigned,
                RoutePrivilegeNames.PlantAdministration
            ],
            favouritesTitle: '[ParentPageName]',
        },
        children: [
            ...PlantAdministrationRoutes
        ]
    },
    {
        path: 'Upgrade',
        data: {
            title: __asyncI18n('Upgrade', 'subnavi.administration.upgrade'),
            category: 'administration',
            testId: 'sidenavigation.link.administration-upgrade',
            favouritesType: 'siteadministration',
            privileges: [
                RoutePrivilegeNames.SiteBatchUpgrade
            ],
            favouritesTitle: '[ParentPageName]',
        },
        children : [
            {
                path: '',
                component: BatchUpgradeListComponent,
                data: {
                    title: __asyncI18n('Upgrade', 'subnavi.administration.upgrade'),
                    category: 'administration',
                    testId: 'sidenavigation.link.administration-upgrade',
                    favouritesType: 'siteadministration',
                    privileges: [
                        RoutePrivilegeNames.SiteBatchUpgrade
                    ],
                    favouritesTitle: '[ParentPageName]'
                },
            },
            {
                path: 'Schedule',
                component: BatchUpgradeScheduleListComponent,
                data: {
                    title: __asyncI18n('Schedule Upgrade', 'subnavi.administration.upgrade.schedule'),
                    category: 'administration',
                    testId: 'sidenavigation.link.administration-upgrade',
                    favouritesType: 'siteadministration',
                    privileges: [
                        RoutePrivilegeNames.SiteBatchUpgrade
                    ],
                    favouritesTitle: '[ParentPageName]',
                    dontShowInSubNavigation: true,
                    dontShowFavourites: true,
                    showParentInSubNavigation: true,
                    showSubNaviLevel: 1
                },
                children: [
                    {
                        path: ':batchupgradeid',
                        component: BatchUpgradeScheduleListComponent,
                        data: {
                            title: __asyncI18n('Schedule Upgrade', 'subnavi.administration.upgrade.schedule'),
                            category: 'administration',
                            testId: 'sidenavigation.link.administration-upgrade',
                            favouritesType: 'siteadministration',
                            privileges: [
                                RoutePrivilegeNames.SiteBatchUpgrade
                            ],
                            favouritesTitle: '[ParentPageName]',
                            dontShowInSubNavigation: true,
                            dontShowFavourites: true,
                            showParentInSubNavigation: true,
                            showSubNaviLevel: 1
                        }
                    }]
            },
            {
                path: ':batchupgradeid',
                component: BatchUpgradeDetailsComponent,
                data: {
                    title: ':batchupgradeid | batchUpgradeIdToName',
                    category: 'administration',
                    testId: 'sidenavigation.link.administration-upgrade.details',
                    favouritesType: 'siteadministration',
                    privileges: [
                        RoutePrivilegeNames.SiteBatchUpgrade
                    ],
                    favouritesTitle: '[ParentPageName] / [PageName]',
                    dontShowInSubNavigation: true,
                    dontShowFavourites: true,
                    showParentInSubNavigation: true,
                    showSubNaviLevel: 1
                }
            }
        ]
    },
    {
        path: 'User',
        data: {
            title: __asyncI18n('Users', 'subnavi.administration.users'),
            contentRoute: '/SystemAdministration/User/List',
            showParentInSubNavigation: true,
            testId: 'sidenavigation.link.users',
            favouritesType: 'users',
            favouritesRouteColor: 'natural-yellow',
            favouritesRouteTitle: '[MainPageName]',
            favouritesTitle: '[ParentPageName]',
            privileges: [
                RoutePrivilegeNames.TenantUsers
            ],
        },
        children: [
            ...UserRoutes
        ]
    },
    {
        path: 'TenantsOld',
        data: {
            title: __asyncI18n('Tenants old', 'subnavi.administration.tenats'),
            contentRoute: '/SystemAdministration/Tenant/List',
            privileges: [
                "NonExistingPrivilege"
            ],
            favouritesCaption: '[PageName]',
            favouritesRouteTitle: '[MainPageName]',
            favouritesTitle: '[ParentPageName]',
        },
        children: [
            ...TenantRoutes
        ]
    },
    {
        path: 'Tenants',
        data: {
            title: __asyncI18n('Tenants', 'subnavi.administration.tenats'),
            testId: 'sidenavigation.link.tenants',
            privileges: [
                RoutePrivilegeNames.BillingAdmin,
                RoutePrivilegeNames.TenantManage
            ],
            favouritesCaption: '[PageName]',
            favouritesRouteTitle: '[MainPageName]',
            favouritesTitle: '[ParentPageName]',
        },
        children: [
            ...NewTenantRoutes
        ]
    },
    {
        path: 'UserRoles',
        data: {
            title: __asyncI18n('Roles', 'subnavi.administration.userroles'),
            contentRoute: '/SystemAdministration/UserRole/List',
            testId: 'sidenavigation.link.userroles',
            privileges: [RoutePrivilegeNames.PlantRolesManage],
            favouritesCaption: FavouriteTileTokens.pageName,
            favouritesRouteTitle: FavouriteTileTokens.mainPageName,
            favouritesTitle: FavouriteTileTokens.parentPageName,
            favouritesRouteColor: 'natural-green'
        },
        children: [
            {
                path: '',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Roles', 'subnavi.administration.userroles'),
                    contentRoute: '/SystemAdministration/UserRole/List'
                }
            },
            {
                path: 'Add',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Add user role', 'subnavi.administration.adduserrole'),
                    contentRoute: '/SystemAdministration/UserRole/Settings',
                    showSubNaviLevel: 1,
                    dontShowInBreadCrumb: true
                }
            },
            {
                path: ':userroleid',
                data: {
                    title: userRoleTitle,
                    redirectTo: '/Administration/UserRoles/:userroleid/Details',
                    dontShowInSubNavigation: true,
                    notClickableInBreadCrumb: true,
                    favouritesRouteCaption: FavouriteTileTokens.pageName,
                    favouritesTitle: FavouriteTileTokens.parentParentPageName
                },
                children: [
                    {
                        path: '',
                        component: DummySiteComponent,
                        data: {
                            title: userRoleTitle,
                            redirectTo: '/Administration/UserRoles/:userroleid/Details',
                            dontShowInSubNavigation: true,
                            notClickableInBreadCrumb: true,
                            favouritesRouteCaption: FavouriteTileTokens.pageName,
                            favouritesTitle: FavouriteTileTokens.parentParentPageName
                        }
                    },
                    {
                        path: 'Details',
                        component: WinFormsContentScreen,
                        data: {
                            title: userRoleTitle,
                            contentRoute: '/SystemAdministration/UserRole/Settings/:userroleid',
                            showSubNaviLevel: 1,
                            dontShowInBreadCrumb: true,
                            favouritesRouteCaption: FavouriteTileTokens.pageName,
                            favouritesTitle: FavouriteTileTokens.parentParentPageName
                        }
                    },
                    {
                        path: 'Settings',
                        component: WinFormsContentScreen,
                        data: {
                            title: userRoleTitle,
                            contentRoute: '/SystemAdministration/UserRole/Settings/:userroleid',
                            showSubNaviLevel: 1,
                            dontShowInBreadCrumb: true,
                            favouritesRouteCaption: FavouriteTileTokens.pageName,
                            favouritesTitle: FavouriteTileTokens.parentParentPageName
                        }
                    }
                ]
            }
        ]
    },
    {
        path: 'ActivatingMultibleSites',
        component: PreregisterComponent,
        canActivate: [PreregisterNavigationAccessService],
        data: {
            title: __asyncI18n('Pre-register', 'subnavi.administration.preregister'),
            breadcrumbTitle: __asyncI18n(
                'Pre-register multiple plants',
                'subnavi.administration.preregister.breadcrumb'
            ),
            testId: 'sidenavigation.link.preregister',
            privileges: [RoutePrivilegeNames.PlantPreRegister]
        }
    },
    {
        path: 'DigitalWallet',
        canActivate: [DigitalWalletNavigationAccess],
        loadChildren: () => import('../modules/billing-module/digital-wallet/index')
            .then((m) => m.BillingDigitalWalletModule),
        data: {
            title: __asyncI18n('Digital wallet', 'subnavi.administration.digital-wallet'),
            testId: 'sidenavigation.link.digitalwallet',
            privileges: [RoutePrivilegeNames.DigitalWallet],
            lazyRedirectTo: '/Administration/DigitalWallet/*firstChild',
            showChildrenAsSecondLevel: true
        }
    },
    {
        path: 'M2MRouter',
        data: {
            title: __asyncI18n('M2M router', 'subnavi.administration.m2mrouter'),
            testId: 'sidenavigation.link.m2mrouter',
            privileges: ['M2MRouter']
        },
        children: [
            {
                path: '',
                component: M2MRouterComponent,
                data: {
                    title: __asyncI18n('M2M router', 'subnavi.administration.m2mrouter'),
                    testId: 'sidenavigation.link.m2mrouter',
                    privileges: ['M2MRouter']
                }
            },
            {
                path: ':deviceid',
                component: M2MRouterDetailComponent,
                data: {
                    title: ':deviceid',
                    showSubNaviLevel: 1
                }
            }
        ]
    },
    {
        path: 'LicenseManager',
        data: {
            title: __asyncI18n('License Manager', 'subnavi.administration.licensemanager'),
            testId: 'sidenavigation.link.licensemanager',
            privileges : [
                RoutePrivilegeNames.PlantLicenseAccess,
                RoutePrivilegeNames.PlantLicenseManage
            ]
        },
        children : [
            {
                path: '',
                component: LicenseListComponent,
                data: {
                    title: __asyncI18n('License Manager', 'subnavi.administration.licensemanager'),
                    testId: 'sidenavigation.link.licensemanager',
                    privileges : [
                        RoutePrivilegeNames.PlantLicenseAccess,
                        RoutePrivilegeNames.PlantLicenseManage
                    ]
                },
            },
            {
                path : ':licenseid',
                component: LicenseDetailsComponent,
                data: {
                    title: __asyncI18n('Details', 'subnavi.administration.licensemanagerdetails'),
                    testId: 'sidenavigation.link.licensemanagerdetails',
                    showSubNaviLevel: 1,
                    privileges : [
                        RoutePrivilegeNames.PlantLicenseAccess,
                        RoutePrivilegeNames.PlantLicenseManage
                    ]
                },
            }
        ]
    },
    {
        path: 'ThirdPartyApps',
        data: {
            title: __asyncI18n('Third-Party Apps', 'subnavi.administration.third-party-apps'),
            testId: 'sidenavigation.link.third-party-apps',
            privileges : [
                RoutePrivilegeNames.ThirdPartyApps
            ]
        },
        children : [
            {
                path: '',
                component: ThirdPartyAppsListComponent,
                data: {
                    title: __asyncI18n('Third-Party Apps', 'subnavi.administration.third-party-apps'),
                    testId: 'sidenavigation.link.third-party-apps',
                }
            },
            {
                path: 'Add',
                component: ThirdPartyAppComponent,
                data: {
                    title: __asyncI18n('Create Third-Party App', 'subnavi.administration.third-party-app.create'),
                    testId: 'sidenavigation.link.third-party-app.create',
                    showSubNaviLevel: 1
                },
            },
            {
                path: 'Register',
                component: ThirdPartyAppRegisterComponent,
                data: {
                    title: __asyncI18n('Register Third-Party App', 'subnavi.administration.third-party-app.register'),
                    testId: 'sidenavigation.link.third-party-app.register',
                    showSubNaviLevel: 1
                }
            },
            {
                path: ':thirdpartyid',
                component: ThirdPartyAppComponent,
                data: {
                    title: __asyncI18n('Edit Third-Party App', 'subnavi.administration.third-party-app.edit'),
                    testId: 'sidenavigation.link.third-party-app.edit',
                    showSubNaviLevel: 1
                },
            }
        ]
    },
    {
        path: 'ReleaseNotes',
        loadChildren: () => import('../modules/release-notes-module/editor/index')
            .then((m) => m.ReleaseNotesEditorModule),
        data: {
            title: __asyncI18n('Release notes', 'subnavi.administration.releasenotes'),
            testId: 'sidenavigation.link.releasenotes',
            privileges: ['ReleaseNotes']
        }
    },
    {
        path: 'BillingProduct',
        loadChildren: () => import('../modules/billing-module/products/index').then((m) => m.BillingProductModule),
        data: {
            title: __asyncI18n('Billing products', 'subnavi.administration.billing-product'),
            testId: 'sidenavigation.link.billingproduct',
            privileges: [RoutePrivilegeNames.ProductDefinition],
            favouritesRouteTitle: FavouriteTileTokens.mainPageName,
            favouritesTitle: FavouriteTileTokens.parentPageName,
            favouritesCaption: FavouriteTileTokens.pageName
        },
    },
    {
        path: 'BillingNotificationTemplate',
        data: {
            title: __asyncI18n('Billing notifications', 'subnavi.administration.billing-notification-templates'),
            contentRoute: '/SystemAdministration/BillingNotificationTemplates',
            testId: 'sidenavigation.link.billingnotificationtemplate',
            privileges: [RoutePrivilegeNames.ProductDefinition],
            favouritesRouteTitle: FavouriteTileTokens.mainPageName,
            favouritesTitle: FavouriteTileTokens.parentPageName,
            favouritesCaption: FavouriteTileTokens.pageName
        },
        children: [
            {
                path: '',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n(
                        'Billing notifications',
                        'subnavi.administration.billing-notification-templates'
                    ),
                    contentRoute: '/SystemAdministration/BillingNotificationTemplate/List'
                }
            },
            {
                path: ':billingnotficationid',
                data: {
                    title: ':billingnotficationid | billingNotificationTemplateIdToName',
                    showSubNaviLevel: 1,
                    redirectTo: 'Administration/BillingNotificationTemplate/:billingnotficationid/Settings',
                    favouritesCaption: FavouriteTileTokens.pageName
                },
                children: [
                    {
                        path: '',
                        component: DummySiteComponent,
                        data: {
                            title: ':billingnotficationid | billingNotificationTemplateIdToName',
                            showSubNaviLevel: 1,
                            redirectTo: 'Administration/BillingNotificationTemplate/:billingnotficationid/Settings',
                            favouritesCaption: FavouriteTileTokens.pageName
                        }
                    },
                    {
                        path: 'Settings',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n(
                                'Settings',
                                'subnavi.administration.billing-notification-template.settings'
                            ),
                            contentRoute:
                                '/SystemAdministration/BillingNotificationTemplate/Settings/:billingnotficationid',
                            showSubNaviLevel: 1,
                            files: [
                                { path: '/Content/codemirror/css', type: RoutingLoadableFiles.css },
                                { path: '/bundles/codemirror', type: RoutingLoadableFiles.js }
                            ],
                            favouritesCaption: FavouriteTileTokens.parentPageName
                        }
                    }
                ]
            }
        ]
    },
    {
        path: 'Notifications',
        component: GlobalNotificationAdministrationComponent,
        data: {
            title: __asyncI18n('System notifications', 'subnavi.administration.notification'),
            contentRoute: '/SystemAdministration/Notification',
            testId: 'sidenavigation.link.notifications',
            privileges: [RoutePrivilegeNames.SystemNotifications],
            favouritesCaption: FavouriteTileTokens.pageName
        }
    }
];
